import {loadStripe} from '@stripe/stripe-js';
import config from '@/config/index';

export const getStripe = () => loadStripe(config.stripeApiKey);

